import { SectionHeader } from "@octopusdeploy/design-system-components";
interface FormSectionHeadingProps {
    title: string | JSX.Element;
    description?: string | JSX.Element;
}
export default function FormSectionHeading(props: FormSectionHeadingProps) {
    return <SectionHeader title={props.title} description={props.description}/>;
}
